
export const isEditingAllowed = (state) => {
  return state.onlineStatus || state.offlinePersistenceEnabled
}

export const currentSession = (state, getters, rootState) => {
  return ((rootState.auth.currentUser || {}).sessions || [])[rootState.ui.currentSessionIndex] ||
    {
      name: '',
      expandedTreeNoteIds: []
    }
}
